import axios from "axios";
import END_POINTS from "./api";

export const fetchContact = async () => {
	const response = await axios.get(END_POINTS.Contact);
	return response.data;
};
